import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import store from '../store'
import {setLN, setPageCode} from "@/util/auth";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    // 支持路径参数：/page/health_welfare_h5
    path: '/page/:pageCode',
    name: 'HomeWithPageCode',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 从路由中获取参数
  const routeParams = {
    ...to.params,
    ...to.query,
    fullPath: to.fullPath,
    timestamp: Date.now()
  }
  setLN(routeParams.ln)
  setPageCode(routeParams.pageCode)

  // 存储到 Vuex
  store.dispatch('loadRouteParams', routeParams)

  next()
})
export default router
